import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../common/api/ApiRequestAdapter";
import { apiService } from "../../common/api/apiService";
import { HttpMethod } from "../../common/api/http";
import { EntityIdObject, EntityObject } from "../../common/types";
import { serializeParams } from "../../common/utils/apiUtils";
import {
  CreateUpdateInstitution,
  Institution,
  InstitutionFilterExportRequest,
  InstitutionFilterPageRequest,
  InstitutionFilterPageResult,
  InstitutionSettings,
  UpdateInstitutionSettings,
} from "./types";

const FILTER_INSTITUTIONS = ApiRequestAdapter.create("/institutions", HttpMethod.GET);
const DOWNLOAD_INSTITUTIONS_EXPORT = ApiRequestAdapter.create("/institutions/export", HttpMethod.GET);
const GET_INSTITUTION = ApiRequestAdapter.create("/institutions/{0}", HttpMethod.GET);
const CREATE_INSTITUTION = ApiRequestAdapter.create("/institutions", HttpMethod.POST);
const UPDATE_INSTITUTION = ApiRequestAdapter.create("/institutions/{0}", HttpMethod.PUT);
const UPDATE_INSTITUTION_SETTINGS = ApiRequestAdapter.create("/institutions/{0}/settings", HttpMethod.PUT);
const DELETE_INSTITUTION = ApiRequestAdapter.create("/institutions/{0}", HttpMethod.DELETE);

export const institutionApi = {
  filterInstitutions: (request: InstitutionFilterPageRequest): AxiosPromise<InstitutionFilterPageResult> => {
    return apiService.get(FILTER_INSTITUTIONS.url, {
      params: request,
      paramsSerializer: { serialize: serializeParams },
    });
  },
  downloadInstitutionsExport: (request: InstitutionFilterExportRequest): AxiosPromise<Blob> => {
    return apiService.get(DOWNLOAD_INSTITUTIONS_EXPORT.url, {
      params: request,
      paramsSerializer: { serialize: serializeParams },
      responseType: "blob",
    });
  },
  getInstitution: (request: EntityIdObject): AxiosPromise<Institution> => {
    return apiService.get(GET_INSTITUTION.getParametrizedUrl(request.id));
  },
  createInstitution: (request: CreateUpdateInstitution): AxiosPromise<Institution> => {
    return apiService.post(CREATE_INSTITUTION.url, request);
  },
  updateInstitution: (request: EntityObject<CreateUpdateInstitution>): AxiosPromise<Institution> => {
    return apiService.put(UPDATE_INSTITUTION.getParametrizedUrl(request.id), request.object);
  },
  updateInstitutionSettings: (request: EntityObject<UpdateInstitutionSettings>): AxiosPromise<InstitutionSettings> => {
    return apiService.put(UPDATE_INSTITUTION_SETTINGS.getParametrizedUrl(request.id), request.object);
  },
  deleteInstitution: (request: EntityIdObject): AxiosPromise => {
    return apiService.delete(DELETE_INSTITUTION.getParametrizedUrl(request.id));
  },
};
